import { defineMessages } from 'react-intl.macro';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import { useMessage } from '@tmapy/intl';
import { SvgSearch, Form, Input, CtaBtn, InputProps } from '@tmapy/style-guide';

import './Search.scss';
import { lastCatalogUrlState } from './CatalogList';

import { actionLoadData, actionSetEndpointQuery } from '../actions';
import { ENDPOINT_CATALOG_DATA } from '../constants';

import { CATALOG_LIST_PATH } from './Router';

const msg = defineMessages({
  buttonLabel: { id: 'search.buttonLabel', defaultMessage: 'Hledat' },
});

export const Search: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const search = useSelector((state) => state.edas.catalogData.query.fts ?? '');

  const handleSubmit = useCallback(() => {
    if (location.pathname !== CATALOG_LIST_PATH) {
      navigate(CATALOG_LIST_PATH, { state: lastCatalogUrlState.state });
    } else {
      dispatch(actionLoadData({ endpoint: ENDPOINT_CATALOG_DATA }));
    }
  }, [dispatch, navigate, location.pathname]);

  const handleChange: InputProps['onChange'] = useCallback(
    (_, eventData) => {
      dispatch(
        actionSetEndpointQuery({
          endpoint: ENDPOINT_CATALOG_DATA,
          query: { fts: eventData.value },
        }),
      );
    },
    [dispatch],
  );

  const formatMessage = useMessage();
  return (
    <Form onSubmit={handleSubmit}>
      <div className='e-search'>
        <div className='e-search--input'>
          <Input value={search} icon={<SvgSearch />} onChange={handleChange} />
        </div>
        <div className='e-search--btn'>
          <CtaBtn type='submit'>{formatMessage(msg.buttonLabel)}</CtaBtn>
        </div>
      </div>
    </Form>
  );
};
